/**
 * Accordion functionality used for project facts in small browsers
 */

class Accordion {

    constructor() {
        let accordionButtons = document.querySelectorAll('.js-accordion-trigger');

        for (let i = 0; i < accordionButtons.length; ++i) {
            accordionButtons[i].classList.remove('accordion--is-active');
            accordionButtons[i].nextElementSibling.classList.remove('accordion--is-expanded');

            accordionButtons[i].addEventListener('click', this.toggleAccordion);
        }
    }

    toggleAccordion() {
        let accordionButton = this;
        let accordionContent = accordionButton.nextElementSibling;

        accordionButton.classList.toggle('accordion--is-active');
        accordionContent.classList.toggle('accordion--is-expanded');
    }
}

export default Accordion;



// WEBPACK FOOTER //
// ./components/views/accordion.js